<div
  #track
  class="slider-button-track"
  [attr.data-variant]="variant"
  [attr.data-size]="size"
  [class.disabled]="disabled"
  [class.loading]="loading"
  [class.dragging]="dragging"
  [class.confirmed]="isConfirmed"
  [style.--thumb-width]="thumbWidth + 'px'"
  (click)="onTrackClick()"
>
  <!-- Filled progress overlay -->
  <div
    class="slider-button-fill"
    [class.hinting]="isHinting"
    [style.width.px]="
      isHinting ? null : offsetX + thumbWidth + trackPadding * 2
    "
  ></div>

  <!-- Slide label (fades while dragging) -->
  <span
    class="slider-button-label"
    [class.hidden]="isConfirmed"
    [style.opacity]="labelOpacity"
  >
    {{ label }}
  </span>

  <!-- Confirmed label -->
  <span class="slider-button-confirmed-label" [class.visible]="isConfirmed">
    <umss-icon
      [name]="confirmedIconName"
      [size]="computedIconSize"
      [color]="iconColor"
    ></umss-icon>
    <span>{{ label }}</span>
  </span>

  <!-- Thumb -->
  <div
    #thumb
    class="slider-button-thumb"
    [class.thumb-hidden]="isConfirmed && hideThumbOnConfirm"
    [class.hinting]="isHinting"
    [style.transform]="isHinting ? null : 'translateX(' + offsetX + 'px)'"
    [style.--hint-offset]="hintOffset + 'px'"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp()"
    (pointercancel)="onPointerUp()"
  >
    @if (loading) {
      <!-- Loading spinner -->
      <span class="thumb-icon thumb-icon--loading">
        <umss-icon
          name="phosphorCircleNotch"
          [size]="computedIconSize"
          [color]="iconColor"
        ></umss-icon>
      </span>
    } @else {
      <!-- Arrow icon (slides out) -->
      <span class="thumb-icon thumb-icon--arrow" [class.out]="isConfirmed">
        <umss-icon
          [name]="thumbIconName"
          [size]="computedIconSize"
          [color]="iconColor"
        ></umss-icon>
      </span>
      <!-- Confirmed icon (slides in) -->
      <span class="thumb-icon thumb-icon--confirmed" [class.in]="isConfirmed">
        <umss-icon
          [name]="confirmedIconName"
          [size]="computedIconSize"
          [color]="iconColor"
        ></umss-icon>
      </span>
    }
  </div>
</div>
